<bnd-modal
  [open]="open()"
  (closed)="onCancel()"
  [title]="data()?.title ?? ''"
  size="sm"
>
  <p>{{ data()?.message }}</p>

  <div
    modal-footer
    class="flex gap-2 justify-end"
  >
    @if (data()?.displayCancelButton ?? true) {
      <bnd-button
        type="button"
        [disabled]="isLoading()"
        (click)="onCancel()"
      >
        {{ data()?.cancelButtonLabel || ('NO' | translate) }}
      </bnd-button>
    }
    <bnd-button
      type="button"
      color="primary"
      [disabled]="isLoading()"
      [loading]="isLoading()"
      (click)="onConfirm()"
    >
      {{ data()?.confirmButtonLabel || ('YES' | translate) }}
    </bnd-button>
  </div>
</bnd-modal>
